<script setup lang="ts">
import { useContactsStore } from '@/entities/Stores/Contacts';
import { HotlineButton } from '@/features/CallToHotline';
import { WhatsAppButton } from '@/features/CallToWhatsApp';

interface ContactUsWidgetProps {
  title: string;
  text: string;
}
defineProps<ContactUsWidgetProps>();
const contactsStore = useContactsStore();
</script>

<template>
  <div class="contact-us">
    <div class="contact-us__header">
      {{ $t('installments.flow.contacts.header') }}
    </div>
    <WhatsAppButton :title="title" :text="text" :href="contactsStore.whatsAppLink" />
    <HotlineButton :title="title" :text="text" variant="outline" :phone="contactsStore.phone" />
  </div>
</template>

<style lang="scss" scoped>
@use './ContactUsWidget';
</style>
